import provincesData from "@/utils/elearning/geo/ar-provinces.json";

/**
 * Catálogo estático provincia → municipios de Argentina, usado para la cascada de
 * selección del "municipio de presentación" del certificado (dato estadístico).
 *
 * Fuente: GeoRef / datos.gob.ar (capa de municipios / gobiernos locales). Casos
 * especiales: CABA se representa como una única entrada institucional, y las
 * provincias sin municipios en GeoRef (Santa Cruz, Santiago del Estero) usan sus
 * departamentos. Es data pura horneada; no hay llamadas externas en runtime.
 */
export interface GeoProvince {
  /** Nombre de la provincia (incl. "Ciudad Autónoma de Buenos Aires"). */
  province: string;
  /** Municipios/gobiernos locales de la provincia, ordenados alfabéticamente. */
  municipalities: string[];
}

const PROVINCES = provincesData as readonly GeoProvince[];

/** Nombres de las 24 provincias (incl. CABA), ordenados alfabéticamente. */
export const getProvinces = (): string[] => PROVINCES.map((p) => p.province);

/** Municipios de una provincia; array vacío si el nombre no está en el catálogo. */
export const getMunicipalities = (province: string): string[] =>
  PROVINCES.find((p) => p.province === province)?.municipalities ?? [];

/** `true` si el par provincia/municipio existe en el catálogo. */
export const isKnownMunicipality = (
  province: string,
  municipality: string
): boolean => getMunicipalities(province).includes(municipality);
